// cartUtils.js

// جلب السلة من localStorage
export const getCart = () => {
    return JSON.parse(localStorage.getItem("cart")) || { items: [] };
  };
  
  // إضافة عنصر للسلة
  export const addToCart = (item) => {
    let cart = getCart();
    const existingItem = cart.items.find((i) => i.id === item.id);
  
    if (existingItem) {
      existingItem.quantity += item.quantity || 1;
    } else {
      cart.items.push({ ...item, quantity: item.quantity || 1 });
    }
  
    localStorage.setItem("cart", JSON.stringify(cart));
  };
  
  // تحديث كمية عنصر
  export const updateCartItemQuantity = (id, quantity) => {
    let cart = getCart();
    cart.items = cart.items.map((item) =>
      item.id === id ? { ...item, quantity } : item
    );
    localStorage.setItem("cart", JSON.stringify(cart));
  };
  
  // حذف عنصر من السلة
  export const removeFromCart = (id) => {
    let cart = getCart();
    cart.items = cart.items.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(cart));
  };
  
  // مسح السلة بالكامل
  export const clearCart = () => {
    localStorage.removeItem("cart");
  };